<dgx-components-description-list *ngIf="cs.vm$ | async as vm">
  <dgx-components-description-list-item
    [stacked]="true"
    [title]="vm.cmsData.accountNameField.fieldLabel"
  >
    <p [dgxQmSanitise]="'block'">
      {{ vm.userDirectDebitDetails?.bankDetails?.accountName }}
    </p>
  </dgx-components-description-list-item>

  <dgx-components-description-list-item
    [data]="vm.userDirectDebitDetails?.bankDetails?.accountNo"
    [stacked]="true"
    [title]="vm.cmsData.accountNumberField.fieldLabel"
  />

  <dgx-components-description-list-item
    [data]="vm.userDirectDebitDetails?.bankDetails?.sortCode"
    [stacked]="true"
    [title]="vm.cmsData.sortCodeField.fieldLabel"
  />
</dgx-components-description-list>
